import React from 'react';
import { Check } from 'lucide-react';
import { Button } from 'src/components/ui/button';
import { OTPInput } from './OTPInput';

const OTPVerificationSection = ({
  isVerifyingOTP,
  handleVerifyOTP,
  otpError,
  canResend,
  resendTimeout,
  handleSendOTP,
  contactVerified,
  isOTPSent,
  verified,
  currentOTP,
  otpFocusTrigger,
  submitButtonText = 'Verify',
  onSubmit,
  type = 'contact',
}) => (
  <div className="mt-2">
    <div className="flex justify-between items-center mb-1">
      {isVerifyingOTP && (
        <span className="text-sm text-blue-600 animate-pulse">
          Verifying...
        </span>
      )}
    </div>

    <div>
      <div className="block text-xs font-medium text-gray-400 mb-2 text-center">
        Enter the 4-digit code
      </div>
      <OTPInput
        onChange={handleVerifyOTP}
        disabled={isVerifyingOTP || contactVerified || verified}
        length={4}
        otpError={otpError}
        focusTrigger={otpFocusTrigger}
      />
      <details className="mt-2 text-xs text-gray-600 text-left">
        <summary className="cursor-pointer text-gray-400">
          Didn&apos;t get it?
        </summary>
        <ul className="list-disc pl-5 mt-2 space-y-1">
          <li>Check network and wait 15–45s.</li>
          <li>Ensure your number is correct.</li>
          <li>Request a new code after the timer ends.</li>
        </ul>
      </details>
    </div>

    {otpError && (
      <p className="mt-1 text-xs text-red-500 font-medium">{otpError}</p>
    )}

    <div className="mt-3 flex flex-col gap-2">
      {/* Submit button for email linking flow */}
      {type === 'email' && onSubmit && (
        <Button
          type="button"
          onClick={onSubmit}
          disabled={
            isVerifyingOTP ||
            // For email linking flow, enable when a 4-digit OTP is present
            (type === 'email' && (!currentOTP || currentOTP.length !== 4))
          }
          className="w-fit bg-ah-brand-primary-alt hover:bg-ah-brand-primary-hover text-white mt-2"
        >
          {isVerifyingOTP ? 'Verifying...' : submitButtonText}
        </Button>
      )}

      {/* Verification status */}
      {(contactVerified || verified) && (
        <span className="text-sm text-green-600 flex items-center">
          <Check className="w-4 h-4 mr-1" />
          Verified Successfully
        </span>
      )}

      {/* Legacy contact flow */}
      {type === 'contact' && isOTPSent && !contactVerified && !verified && (
        <div className="flex flex-col gap-1">
          <p className="text-sm text-gray-600 flex items-center gap-1">
            Didn&apos;t receive the OTP on your phone?
            {canResend ? (
              <button
                type="button"
                onClick={() => handleSendOTP('RESEND')}
                className="text-blue-600 hover:text-blue-800 transition-colors duration-200"
              >
                Request again
              </button>
            ) : (
              <span className="text-blue-600 font-medium">
                Resend in {resendTimeout}s
              </span>
            )}
          </p>
          {!canResend && (
            <p className="text-xs text-gray-500">
              Please wait for the timer to complete before requesting a new OTP
            </p>
          )}
        </div>
      )}
    </div>
  </div>
);

export default OTPVerificationSection;
